// extracted by mini-css-extract-plugin
export default {"wrapper":"UserInfo_wrapper__223nR","avatar":"UserInfo_avatar__yl2xN","text":"UserInfo_text__KEpa9","name":"UserInfo_name__LFv7a","id":"UserInfo_id__jnA+Q"};